import React from "react";
import { Container, Paper, Typography, List, ListItem, ListItemText } from "@mui/material";

export default function MembershipAgreementView() {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, sm: 6 } }}>
      <Paper elevation={0} sx={{ p: { xs: 2, sm: 4 } }}>
        <Typography
          variant="h4"
          color="text.secondary"
          align="center"
          fontWeight="bold"
          gutterBottom
        >
          会员购买协议
        </Typography>

        <List dense>
          <ListItem>
            <ListItemText primary="1. 虚拟商品购买后不支持退款，请谨慎决策；" />
          </ListItem>
          <ListItem>
            <ListItemText primary="2. 会员有效期内所有功能无限制使用；" />
          </ListItem>
          <ListItem>
            <ListItemText primary="3. 因不可抗力因素导致服务中断或无法继续提供，我们将尽合理努力及时通知并恢复服务，但不承担由此产生的任何责任，且已支付的会员费用暂不支持退款；" />
          </ListItem>
          <ListItem>
            <ListItemText primary="4. 支付异常请联系邮箱：  2954060395@qq.com。" />
          </ListItem>
        </List>
      </Paper>
    </Container>
  );
}
